<template>
  <div class="contact">
    <pageHeader
      :actNum="5"
      :bannerImg="bannerImg"
      bannerText="- Hoist"
      bannerText2="Efficiency and quality"
    />
    <div class="top">
      <div class="top-left">
        您的位置：<span class="homeSpan" @click="tarHome()">首页</span> >
        联系我们
      </div>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="content-left-top">
          <div class="box">
            <div class="box-title">普康软件（深圳）有限公司</div>
            <div class="box-text">Pukang Software (Shenzhen) Co.,Ltd</div>
          </div>
          <div class="box">
            <div class="box-title">加盟合作</div>
            <div class="box-text">Co­op­er­a­tive Al­liance</div>
          </div>
        </div>
        <div class="content-left-bottom">
          <div class="box">
            <div class="box-text">
              <span>地址：</span>深圳市龙岗区海源创新中心721D3
            </div>
            <div class="box-text"><span>电话：</span>13684985188</div>
            <div class="box-text"><span>邮箱：</span>269068079@qq.com</div>
          </div>
          <div class="box">
            <div class="box-text"><span>联系人：</span>李先生</div>
            <div class="box-text"><span>电话：</span>13684985188</div>
            <div class="box-text"><span>邮箱：</span>269068079@qq.com</div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="text1">服务热线</div>
        <div class="text2">010-88888888</div>
        <div class="text3">售前电话</div>
        <div class="text4">13866666666<span>（李经理）</span></div>
        <div class="text5">服务时间：周一到周五8:30-18:00</div>
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
import bannerImg from "@/assets/img/banner_contact.png";
export default {
  name: "contactUs",
  components: {
    pageHeader,
    footPage,
  },
  data() {
    return {
      bannerImg,
    };
  },
  methods: {
    tarHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  padding: 52px 260px;
  &-left {
    font-size: 14px;
  }
}
.content {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 260px;
  height: 440px;
  color: #333;
  margin-bottom: 175px;
  &-left {
    width: calc(100% - 515px);
    background-color: #fdfdfd;
    &-top {
      display: flex;
      padding: 100px 0 0 72px;
      .box {
        flex: 1;
        &-title {
          font-size: 20px;
        }
        &-text {
          margin-top: 2px;
          font-size: 20px;
          color: #666;
          line-height: 28px;
        }
      }
    }
    &-bottom {
      display: flex;
      padding-left: 72px;
      margin-top: 78px;
      .box {
        flex: 1;
        &-text {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 2px;
          span {
            color: #666;
          }
        }
      }
    }
  }
  &-right {
    width: 515px;
    background-color: #104a62;
    padding: 100px 0 0 74px;
    box-sizing: border-box;
    color: #fff;
    .text1 {
      font-size: 14px;
      line-height: 20px;
    }
    .text2 {
      font-size: 26px;
      line-height: 36px;
      margin-top: 8px;
    }
    .text3 {
      margin-top: 74px;
      line-height: 20px;
      font-size: 14px;
    }
    .text4 {
      font-size: 26px;
      line-height: 36px;
      margin-top: 8px;
      span {
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .text5 {
      margin-top: 25px;
      line-height: 20px;
      font-size: 14px;
    }
  }
}
</style>